import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {lighten} from '@material-ui/core/styles/colorManipulator';
import ProjectTextField from "./ProjectTextField";
import ProjectSelectField from "./ProjectSelectField";
import Grid from '@material-ui/core/Grid';
import Question from "../../../QuestionApplication/components/Question";


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {onSelectAllClick, order, orderBy, numSelected, rowCount, cols} = this.props;
    return (
        <TableHead>
          <TableRow>
            {false && <TableCell padding="checkbox">
              <Checkbox
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={numSelected === rowCount}
                  onChange={onSelectAllClick}
              />
            </TableCell>}
            {cols.filter(x => x.hidden !== true).map(
                (col, key) => (<React.Fragment
                    key={key}>
                  {col.id === 'childItems' && <TableCell
                      align={col.numeric ? 'right' : 'left'}
                      padding={col.disablePadding ? 'none' : 'default'}
                      sortDirection={orderBy === col.id ? order : false}
                  >
                    {col.label}
                  </TableCell>
                  }
                  {col.id !== 'childItems' &&
                  <TableCell
                      align={col.numeric ? 'right' : 'left'}
                      padding={col.disablePadding ? 'none' : 'default'}
                      sortDirection={orderBy === col.id ? order : false}
                  >
                    <Tooltip
                        title="Sort"
                        placement={col.numeric ? 'bottom-end' : 'bottom-start'}
                        enterDelay={300}
                    >
                      <TableSortLabel
                          active={orderBy === col.id}
                          direction={order}
                          onClick={this.createSortHandler(col.id)}
                      >
                        {col.label}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                  }
                </React.Fragment>),
                this,
            )}
          </TableRow>
        </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(1.5),
  },
  highlight:
      theme.palette.type === 'light'
          ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
          : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
    textAlign: 'right',
    width: 500,
    paddingRight: 6
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const {
    numSelected, classes, create, itemType, attachable, attach, attachableItems, attachActive, setAttachActive,
    isEditableItems
  } = props;

  return (
      <Toolbar
          className={classNames(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
      >
        <div className={classes.title}>
          {numSelected > 0 ? (
              <Typography color="inherit" variant="subtitle1">
                {numSelected} selected
              </Typography>
          ) : (
              <Typography variant="h6" id="tableTitle">
                {itemType}
              </Typography>
          )}
        </div>
        <div className={classes.spacer}/>
        {isEditableItems &&
        <div className={classes.actions}>
          {numSelected > 0 ? (
              <Tooltip title="Delete">
                <IconButton aria-label="Delete">
                  <FontAwesomeIcon size="xs" icon={['fal', 'times']}/>
                </IconButton>
              </Tooltip>
          ) : (
              <>
                {!attachActive && <Tooltip title="Create">
                  <IconButton color="primary" aria-label="Create" style={{padding: '12px 14.25px'}}
                              onClick={() => create(itemType)}>
                    <FontAwesomeIcon size="xs" icon={['fal', 'plus']}/>
                  </IconButton>
                </Tooltip>}
                {attachable && <>
                  {!attachActive && <Tooltip title="Attach">
                    <IconButton color="primary" aria-label="Attach"
                                style={{padding: '12px 14.25px'}}
                                onClick={setAttachActive}>
                      <FontAwesomeIcon size="xs" icon={['fal', 'link']}/>
                    </IconButton>
                  </Tooltip>}
                  {attachableItems && attachActive &&
                  <ProjectSelectField options={attachableItems} alias={'attach'} save={attach} size={'sm'}
                                      value={''}/>}</>
                }</>
          )}
        </div>}
      </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  table: {
    //minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  paginationSelect: {
    paddingRight: theme.spacing(2.5),
  },
  noTextData: {
    color: 'rgba(0,0,0,0.5)'
  },
  detachButton: {
    color: '#ff9800',
  },
  trashButton: {
    padding: 4,
    marginTop: -5,
    fontSize: '1rem',
  }
});

class ProjectSubItems extends Component {
  state = {
    order: 'asc',
    orderBy: 'order',
    selected: [],
    data: [],
    page: 0,
    rowsPerPage: 100,
    attachActive: false,
  };

  componentDidMount() {
    this.updateState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.state.data) {
      this.updateState(nextProps)
    }
  }

  updateState(props) {
    this.setState({
      data: props.data,
      cols: props.cols,
    })
  }


  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({order, orderBy});
  };

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState(state => ({selected: state.data.map(n => n.id)}));
      return;
    }
    this.setState({selected: []});
  };

  handleSelectRowClick = (event, id) => {
    const {selected} = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
      );
    }

    this.setState({selected: newSelected});
  };

  handleClick = (event, id) => {

  };

  handleChangePage = (event, page) => {
    this.setState({page});
  };

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value});
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  attachSave = (id, alias, value) => {
    this.props.attach(this.props.itemType, value)
    this.setState({attachActive: false});
  }

  setAttachActive = () => {
    this.setState({attachActive: true});
  }

  getNotSelectedOptions = (sourceArray, selectedArray, title) => {
    const notSelectedArray = sourceArray.filter(option => {
      const hasValue = selectedArray.some(el => {
        const exists = el.childOptionId === option.value
        return exists
      })
      return !hasValue
    })
    return notSelectedArray
  }

  isEditableItems = (cols) => {
    const isEditableItems = cols && cols.find(x => x.id === 'actions')
    return isEditableItems
  }

  render() {
    const {
      classes, update, itemType, save, create, attachable, detach, attach, attachableItems, createChildItem, onChildItemValueChanged,
      deleteChildItem
    } = this.props;
    const {data, order, orderBy, selected, rowsPerPage, page, cols, attachActive} = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    const isEditableItems = this.isEditableItems(cols)

    return (
        <Paper className={classes.root}>
          <EnhancedTableToolbar numSelected={selected.length} create={create} itemType={itemType}
                                attachableItems={attachableItems} attachActive={attachActive}
                                setAttachActive={this.setAttachActive}
                                attachable={attachable} attach={this.attachSave}
                                isEditableItems={isEditableItems}/>
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              {cols && <EnhancedTableHead
                  cols={cols}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={this.handleSelectAllClick}
                  onRequestSort={this.handleRequestSort}
                  rowCount={data.length}
              />}
              <TableBody>
                {stableSort(data, getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n, key) => {
                      const isSelected = this.isSelected(n.id);
                      return (
                          <TableRow
                              onClick={event => this.handleClick(event, n.id)}
                              role="checkbox"
                              aria-checked={isSelected}
                              tabIndex={-1}
                              key={key}
                              selected={isSelected}
                          >
                            {false &&
                            <TableCell padding="checkbox">
                              <Checkbox checked={isSelected}/>
                            </TableCell>}
                            {cols &&
                            cols.filter(x => x.hidden !== true).map((col, colKey) => {
                                  if (col.id === 'childItems') {
                                    return (
                                        <TableCell align={'left'} key={colKey}>
                                          {n[col.id].map((childItem, childItemKey) => {
                                            return (
                                                <Grid container spacing={1} key={childItemKey}
                                                      style={{minWidth: 500, paddingTop: childItemKey === 0 ? 12 : 0}}>
                                                  <Grid item xs={5}>
                                                    {childItem.label}
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Question question={{
                                                      id: childItem['itemId'],
                                                      itemType: childItem['itemType'],
                                                      type: 'slider',
                                                      adminSlider: true,
                                                      xsCols: 12,
                                                      smCols: 12,
                                                      min: -100,
                                                      max: 100,
                                                      alias: childItem['alias'],
                                                      value: childItem.value
                                                    }} onValueChanged={onChildItemValueChanged}/>
                                                  </Grid>
                                                  <Grid item xs={1}>
                                                    <IconButton
                                                        color="secondary"
                                                        aria-label="Remove"
                                                        onClick={() => deleteChildItem(childItem['itemType'], childItem['itemId'])}
                                                        className={classes.trashButton}
                                                    >
                                                      <FontAwesomeIcon size="xs" icon={['fal', 'trash']}/>
                                                    </IconButton>
                                                  </Grid>
                                                </Grid>
                                            )
                                          })}
                                          {n['type'] === 'selectButtons' && n['possibleChildItems'] &&
                                          <ProjectSelectField
                                              options={this.getNotSelectedOptions(n['possibleChildItems'].options, n['childItems'], n['title'])}
                                              alias={'QuestionOption'} save={createChildItem} size={'sm'} id={n['id']}
                                              value={''} toggleable={true}/>
                                          }
                                          {n['type'] === 'slider' &&
                                          <ProjectTextField
                                              alias={'QuestionOption'} save={createChildItem} size={'sm'} id={n['id']}
                                              value={''} toggleable={true}/>
                                          }
                                        </TableCell>)

                                  } else if (col.id === 'actions') {
                                    return (
                                        <TableCell align="right" key={'actions'}>
                                          <IconButton color="primary" aria-label="Create"
                                                      onClick={() => update({
                                                        itemType: itemType,
                                                        id: n.id,
                                                        action: 'edit'
                                                      })}>
                                            <FontAwesomeIcon size="xs" icon={['fal', 'pencil']}/>
                                          </IconButton>

                                          {attachable &&
                                          <IconButton color="primary" aria-label="Create" className={classes.detachButton}
                                                      onClick={() => detach(itemType, n.id)}>
                                            <FontAwesomeIcon size="xs" icon={['fal', 'unlink']}/>
                                          </IconButton>}
                                        </TableCell>)
                                  } else {
                                    return (
                                        <TableCell align={col.numeric ? 'right' : 'left'} key={colKey}>
                                          {!col.numeric && n[col.id] === '' && !col.editable &&
                                          <span className={classes.noTextData}>(empty)</span>}
                                          {!(!col.numeric && n[col.id] === '' && !col.editable) && (<>
                                                {col.editable &&
                                                <ProjectTextField alias={col.id} type={'text'} label={''} id={n.id}
                                                                  save={save} size={'sm'}
                                                                  itemType={itemType}
                                                                  value={n[col.id]}/>}
                                                {!col.editable &&
                                                <>
                                                  {!col.link && n[col.id]}
                                                  {col.link &&
                                                  <a href={n[col.id]}>
                                                    <FontAwesomeIcon size="lg" icon={['fal', 'magic']}/>
                                                  </a>}
                                                </>}
                                              </>
                                          )

                                          }
                                        </TableCell>
                                    )
                                  }
                                }
                            )
                            }
                          </TableRow>
                      );
                    })}
                {emptyRows > 0 && (
                    false && <TableRow style={{height: 49 * emptyRows}}>
                      <TableCell colSpan={6}/>
                    </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              classes={{select: classes.paginationSelect}}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
    );
  }
}

ProjectSubItems.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectSubItems);
